import http from './http';
//获取直播分类
export function getLiveCategorys() {
  return http.get('/live/categorys');
}
//获取直播列表
/**
 * category_id	string			
分类ID  
keyword	string			
队伍，联赛名称  
type	int			
1我的关注  
state	int		9	
0待开赛，1已经开赛，2已完结, 3精彩回放 .9全部默认值  
start_time  string 开始时间 格式时间戳
 * 
 */

export function getLiveList(data: { category_id: string; type: any; state: string;start_time?: number; keyword?: string }) {
  return http.post('/live/index', data);
}

//添加直播比赛关注
export function getliveFocusAdd(data: { id: string;}) {
  return http.post('/liveFocus/add', data);
}
//取消直播比赛关注
export function getliveFocusDel(data: { id: string;}) {
  return http.post('/liveFocus/out', data);
}

//获取比赛队伍列表
/**
 * keyword	string			
标题｜标签  
category_id	int			
类型  
type	int			
1我的关注  
page_size	int		15	
当前条数  
page	int		1	
当前页  
 * @param data 
 * @returns 
 */
export function getmatchTeamList(data: { category_id: string; type: any; keyword?: string, page_size?: number; page?: number ;}) {
  return http.get('/matchTeam/index',{ params: data });
}

//添加关注比赛队伍
export function getmatchTeamAdd(data: { id: string;}) {
  return http.post('/matchTeamFocus/add', data);
}
//取消关注比赛队伍
export function getmatchTeamDel(data: { id: string;}) {
  return http.post('/matchTeamFocus/out', data);
}